/* global $ */
import Vue from 'vue'
import Router from 'vue-router'
import DashboardRoutes from '@/components/dashboard/routes'

Vue.use(Router)

function load(component) {
  // '@' is aliased to src
  return () => import(`@/components/${component}.vue`)
}

function titleEvent() {
  return new Promise((resolve) => {
    $(window).one('title-change', () => {
      resolve(document.title)
    })
  })
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: load('OfflineLayout'),
      children: [
        {
          path: '',
          name: 'HomePage',
          component: load('HomePage'),
        },
        {
          path: 'colocation-proprietaire-avantages',
          name: 'OwnerLandingPage',
          component: load('OwnerLandingPage'),
        },
        {
          path: 'signupselect',
          name: 'SignUpSelect',
          component: load('users/SignupSelect'),
        },
        {
          path: 'signup',
          name: 'SignUpColocSelect',
          component: load('users/SignupColocSelect'),
        },
        {
          path: 'signup/:type(users|proprietaire|prop-occupant|agent|manager)',
          name: 'SignUp',
          component: load('users/Signup'),
        },
        {
          path: 'signin',
          name: 'SignIn',
          component: load('users/Signin'),
        },
        {
          path: 'signout',
          name: 'SignOut',
          component: load('users/Signout'),
        },
        {
          path: 'access',
          name: 'NoAccess',
          component: load('users/Signin'),
        },
        {
          path: 'reset_password',
          name: 'ResetPassword',
          component: load('users/ResetPassword'),
        },
        {
          path: 'reset_password/email',
          name: 'ResetPasswordEmail',
          component: load('users/ResetPasswordEmail'),
        },
        {
          path: 'reset_password/new_password',
          name: 'ResetPasswordNew',
          component: load('users/ResetPasswordNew'),
        },
        {
          path: 'quicksearch',
          name: 'QuickSearch',
          component: load('searches/QuickSearch'),
        },
        {
          path: 'charte-de-bonne-conduite',
          name: 'Conduct',
          component: load('layouts/Conduct'),
        },
        {
          path: 'politique-de-confidentialite',
          name: 'LegalText',
          component: load('layouts/Legal'),
        },
        {
          path: 'faq',
          name: 'FAQ',
          component: load('layouts/FAQ'),
        },
        {
          path: 'mentions-legales',
          name: 'Mentions',
          component: load('layouts/Mentions'),
        },
        {
          path: 'cgu',
          name: 'CGU',
          component: load('layouts/CGU'),
        },
        {
          path: 'qui-sommes-nous',
          name: 'About',
          component: load('layouts/About'),
        },
        {
          path: 'contact',
          name: 'Contact',
          component: load('layouts/Contact'),
        },
      ],
    },
    {
      path: '/',
      component: load('AdvertLayout'),
      children: [
        {
          path: 'colocation-:path/:home_id',
          name: 'ViewAdvert',
          component: () => import('@/components/dashboard/pages/ViewAdvert'),
          meta: {
            stayAfterSignin: true,
            stayAfterSignout: true,
          },
        },
        {
          path: 'confirmation-visite',
          name: 'ConfirmVisit',
          component: () => import('@/components/ConfirmationVisite'),
        },
      ],
    },
    {
      path: '/coliveo',
      name: 'coliveo',
      component: load('Coliveo/index'),
    },
    DashboardRoutes,
    {
      path: '/registration/:path',
      name: 'registration',
      component: load('layouts/Registration-v2'),
      meta: {
        title: titleEvent,
      },
    },
    {
      path: '/agent/:path/:home_id',
      name: 'agent',
      component: load('layouts/Registration-v2'),
      meta: {
        title: titleEvent,
      },
    },
    {
      path: '/manager/:path/:home_id',
      name: 'manager',
      component: load('layouts/Registration-v2'),
      meta: {
        title: titleEvent,
      },
    },
    {
      path: '/proprietaire/:path/:home_id',
      name: 'proprietaire',
      component: load('layouts/Registration-v2'),
      meta: {
        title: titleEvent,
      },
    },
    {
      path: '/users/services',
      name: 'DashboardServices',
      component: load('layouts/DashboardServices'),
      meta: {
        title: 'COOLOC | Services',
      },
    },
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: load('Error401'),
    },
    // Always leave this last one
    {
      path: '*',
      name: 'NotFound',
      component: load('Error404'),
    },
  ],
})
